export const SET_QUESTION = 'SET_QUESTION';
export const SET_ANSWER = 'SET_ANSWER';
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const REMOVE_ALL_ANSWERS = 'REMOVE_ALL_ANSWERS';
export const SET_TIME = 'SET_TIME';
export const SET_SKIPPED = 'SET_SKIPPED';